import solarIcon from "../../images/region-picker/solar-environment-256w-glow.png";
import earthMagIcon from "../../images/region-picker/earth-magnetosphere-256w-glow.png";
import earthAtmIcon from "../../images/region-picker/earth-atmosphere-256w-glow.png";
import interplanetaryIcon from "../../images/region-picker/interplanetary-256w-glow.png";
import planetaryMagIcon from "../../images/region-picker/planetary-magnetosphere-256w-glow.png";
import learnHelioImg from "../../images/entrypoint-content/H_0322_HeliopauseCycle_v01.00680_print.jpg";
import dataOriginsImg from "../../images/entrypoint-content/mission-fleet.jpg";
import stepGuideBadges from "../../images/step-guide-badges.svg";

/**
 * Region taxonomy for the "Data by Region" navigation. The region to
 * sub-region mapping is intentionally hardcoded here, mirroring how the
 * footer hardcodes regions, so the navigation has no backend dependency.
 *
 * Grid order places Planetary Magnetospheres (the tallest block) in row 2 so
 * the two rows stay close in height; the sixth grid cell is left blank.
 */
export const regionNav = [
  {
    key: "sun",
    name: "Solar Environment",
    icon: solarIcon,
    landingPath: "/region/sun",
    subRegions: [
      { name: "Solar Interior", path: "/region/solar-interior" },
      { name: "Photosphere", path: "/region/photosphere" },
      { name: "Chromosphere", path: "/region/chromosphere" },
      { name: "Corona", path: "/region/corona" },
    ],
  },
  {
    key: "earth-magnetosphere",
    name: "Earth Magnetosphere",
    icon: earthMagIcon,
    landingPath: "/region/earth-magnetosphere",
    subRegions: [
      { name: "Inner Magnetosphere", path: "/region/earth-inner-magnetosphere" },
      { name: "Outer Magnetosphere", path: "/region/earth-outer-magnetosphere" },
      { name: "Magnetosheath", path: "/region/earth-magnetosheath" },
      { name: "Magnetotail", path: "/region/earth-magnetotail" },
    ],
  },
  {
    key: "earth-atmosphere",
    name: "Earth Atmosphere",
    icon: earthAtmIcon,
    landingPath: "/region/earth-atmosphere",
    subRegions: [
      { name: "Lower/Middle Atmosphere", path: "/region/earth-lower-atmosphere" },
      { name: "Thermosphere", path: "/region/earth-thermosphere" },
      { name: "Ionosphere", path: "/region/earth-ionosphere" },
      { name: "Auroral Subregion", path: "/region/earth-auroral-region" },
    ],
  },
  {
    key: "interplanetary-space",
    name: "Interplanetary Space",
    icon: interplanetaryIcon,
    landingPath: "/region/interplanetary-space",
    subRegions: [
      { name: "Solar Wind", path: "/region/solar-wind" },
      { name: "Earth Magnetosheath", path: "/region/earth-magnetosheath" },
      { name: "Heliosheath", path: "/region/heliosheath" },
    ],
  },
  {
    key: "planetary-magnetospheres",
    name: "Planetary Magnetospheres",
    icon: planetaryMagIcon,
    landingPath: "/region/planetary-magnetospheres",
    subRegions: [
      { name: "Mars", path: "/region/mars" },
      { name: "Jupiter", path: "/region/jupiter" },
      { name: "Saturn", path: "/region/saturn" },
      { name: "Uranus", path: "/region/uranus" },
      { name: "Neptune", path: "/region/neptune" },
    ],
  },
];

/**
 * "About Us" navigation groups. Mirrors the footer's "About Heliophysics
 * Data" and "About Us" sections; Contact Us is split into its own callout.
 */
export const aboutGroups = {
  aboutData: {
    label: "About Heliophysics Data",
    links: [
      {
        text: "Learn about Heliophysics",
        // sub: "What heliophysics is and why it matters",
        image: learnHelioImg,
        link: "/learn-about-helio",
      },
      {
        text: "Where the Data Comes From",
        // sub: "Missions, instruments & the SPASE catalog",
        image: dataOriginsImg,
        link: "/where-it-comes-from",
      },
      {
        text: "Step-by-Step User Guide",
        // sub: "Downloading & acquiring data",
        image: stepGuideBadges,
        link: "/downloading-and-acquiring",
      },
    ],
  },
  aboutUs: {
    label: "About Us",
    // `sub` is not shown by the desktop plain-link treatment, but the mobile
    // drill-down still renders it in its flat About list — keep it.
    links: [
      {
        text: "Heliophysics Digital Resource Library",
        sub: "About HDRL",
        link: "/about",
      },
    ],
  },
  contact: {
    label: "Get in touch",
    title: "Contact Us",
    blurb: "For support using the HelioData website or to provide feedback, please contact us if you have inquiries.",
    buttonText: "Email Support",
    email: "heliodata-support-owner@lists.nasa.gov",
  },
};
